import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ProjectCommunicationService } from '../../communication/project-comms.service';
import Utils from '../../util';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { takeUntil } from 'rxjs/operators';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'app-save-cancel-buttons',
  templateUrl: './save-cancel-buttons.component.html',
  styleUrls: ['./save-cancel-buttons.component.scss'],
})
export class SaveCancelButtonsComponent extends UserpilotReloader implements OnInit, OnDestroy {
  @Input() idPrefix = 'save-cancel';
  @Input() formValid = true;
  @Input() bypassPermissions = false;
  @Input() saveButtonText = 'PROJECT.COMMON.SAVE';
  @Input() cancelButtonText = 'PROJECT.COMMON.CANCEL';
  @Input() sidebarCancelText = this.cancelButtonText;
  @Input() showSave = true;
  @Input() showCancel = true;
  @Input() showBottomButtons = true;
  @Input() showSidebarButtons = true;
  @Input() saveButtonType = 'submit';
  /**
   * This enables functionality that will only make the save button
   * green when there are unsaved changes. The unsavedChanges property can be used
   * to set when there are unsaved changes, when there are no unsaved changes
   * the save button will appear gray, but on hover it will still change to green.
   */
  @Input() enableUnsavedChangesBtn = false;
  /**
   * This property is used to set the unsaved changes state of the state button
   * when enableUnsavedChangesBtn is enabled, see above for more info.
   */
  @Input() unsavedChanges = false;
  @Output() cancelClick = new EventEmitter<boolean>();
  @Output() saveClick = new EventEmitter<boolean>();

  @Input() saveConfirmationEnabled = false;
  @Input() saveConfirmMessage = 'PROJECT.COMMON.SAVE_CONFIRM';
  @Input() saveConfirmText = 'PROJECT.COMMON.YES';
  @Input() saveCancelText = 'PROJECT.COMMON.NO';
  @Input() cancelConfirmationEnabled = false;
  @Input() cancelConfirmMessage = 'PROJECT.COMMON.CANCEL_CONFIRM';
  @Input() cancelConfirmText = 'PROJECT.COMMON.YES';
  @Input() cancelRejectText = 'PROJECT.COMMON.NO';

  buttonGroupStyling = 'fatbuttongroup';
  buttonStyling = 'btn-fat';
  showSaveConfirmation = false;
  showSidebarSaveConfirm = false;
  showCancelConfirmation = false;
  showSidebarCancelConfirm = false;

  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger?: string;

  /**
   * basic - standard large save buttons commonly used at bottom of each form page
   * compact - a compact, and narrow style with less padding on the top and bottom
   */
  @Input()
  set styling(input: any) {
    switch (input) {
      case SaveCancelButtonStyling.Compact:
        this.buttonGroupStyling = 'compact-button-group';
        this.buttonStyling = 'btn-compact';
        break;
      case SaveCancelButtonStyling.Wrapped:
        this.buttonGroupStyling = 'fatbuttongroup';
        this.buttonStyling = 'wrapped-btn-fat';
        break;
      default:
        this.buttonStyling = 'btn-fat';
        this.buttonGroupStyling = 'fatbuttongroup';

    }
  }
  constructor(private projectCommService: ProjectCommunicationService,
              public translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  canEditProject() {
    // This is not ideal, but it works
    return Utils.canEditProject() || this.bypassPermissions;
  }


  projectLoaded() {
    return this.projectCommService.projectLoadedValue;
  }

  saveClicked() {
    this.showSidebarSaveConfirm = false;
    if (this.saveConfirmationEnabled) {
      this.showSaveConfirmation = true;
    } else {
      this.saveClick.emit(true);
    }
  }

  sidebarSaveClicked() {
    this.showSaveConfirmation = false;
    if (this.saveConfirmationEnabled) {
      this.showSidebarSaveConfirm = true;
    } else {
      this.saveClick.emit(true);
    }
  }

  confirmSaveClicked() {
    this.saveClick.emit(true);
    this.hideConfirmPopups();
  }

  rejectSaveClicked() {
    this.hideConfirmPopups();
  }

  cancelClicked() {
    this.showSidebarCancelConfirm = false;
    if (this.cancelConfirmationEnabled) {
      this.showCancelConfirmation = true;
    } else {
      this.cancelClick.emit(true);
    }  }

  sidebarCancelClicked() {
    this.showCancelConfirmation = false;
    if (this.cancelConfirmationEnabled) {
      this.showSidebarCancelConfirm = true;
    } else {
      this.cancelClick.emit(true);
    }
  }

  confirmCancelClicked() {
   this.cancelClick.emit(true);
   this.hideConfirmPopups();
  }

  rejectCancelClicked() {
    this.hideConfirmPopups();
  }

  private hideConfirmPopups() {
    this.showSaveConfirmation = false;
    this.showSidebarSaveConfirm = false;
    this.showCancelConfirmation = false;
    this.showSidebarCancelConfirm = false;
  }

  buttonIconsActive() {
    if (window) {
      return window.innerWidth < 1600;
    }
  }
}

export enum SaveCancelButtonStyling {
  Basic = 'basic',
  Compact = 'compact',
  Wrapped = 'wrapped'
}
